import React, { useState } from "react";
import utils from "./utils";
import Image from "./Image";
import styles from "./styles";
import { useRef } from "react";
import { useEffect } from "react";


const GlassRenderer = props => {
  const {
    itemRef,
    itemPosition,
    activePosition,
    elementDimensions,
    itemDimensions,
    active,
    imageSrc,
    largeImageSrc,
    imageAlt,
    magnifierBorderSize,
    square,
    magnifierSize,
    magnifierOffsetX,
    magnifierOffsetY,
    renderOverlay,
    cursorStyle,
    onImageLoad,
    onLargeImageLoad,
    onLoadRefresh,
    callback,
    lang,
    submit
  } = props;

  const [lastDivPosition,setLastDivPosition] = useState({x:0,y:0})
  const [lastPosition,setLastPosition] = useState({x:0,y:0})

  let magnifierBorderColor = props.magnifierBackgroundColor
  let magnifierBackgroundColor = props.magnifierBackgroundColor

  const letters=
  {
    En: ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','/','*','#','@','-','.',' ','DEL'],
    Fa: ['ا','ب','پ','ت','ث','ج','چ','ح','خ','د','ذ','ر','ز','ژ','س','ش','ص','ض','ط','ظ','ع','غ','ف','ق','ک','گ','ل','م','ن','و','ه','ی',' ','DEL']
  }
  

  const [selectedLetter, setSelectedLetter] = useState("")
  const [isFinished, setIsFinished] = useState(false)
  const [isMoved, setIsMoved] = useState(false)
  
  // useEffect(()=>{
  //   // console.log("lang is:", lang)
  // },[lang])

  useEffect(()=>{
    if(isFinished){
      setIsMoved(false)
      setIsFinished(false)
      callback(selectedLetter)
    }
  },[selectedLetter,isFinished])
  useEffect(()=>{
    if(!isMoved){
      magnifierBorderColor= props.magnifierBackgroundColor
      magnifierBackgroundColor="rgba(255,255,255,0.5)"
      setSelectedLetter("")
    }
  },[isMoved])

  const legalSize = itemDimensions.width > elementDimensions.width;
  const isActive = legalSize && active;

  const magnifierSizeNum = utils.convertWidthToPx(
    magnifierSize,
    elementDimensions.width
  );

  const imageRef = useRef(null)
  const magRef = useRef(null)

  const positionOffset = magnifierSizeNum / 2;

  const borderRadius = square ? "0" : "50%";
  let ratio = itemDimensions.width /elementDimensions.width
  
  let middleWidth = elementDimensions.width /2.0
  let middleHeight = elementDimensions.height /2.0
  let distance = Math.sqrt(Math.pow(middleWidth-activePosition.x,2) + Math.pow(middleHeight-activePosition.y,2))
  
  
  let angle = Math.atan2(activePosition.y-middleHeight,activePosition.x-middleWidth)
  let angleStep = 2*Math.PI/34
  let angleOffset = Math.round(angle/angleStep)

  let widthDistanceFromCenter,heigthDistanceFromCenter;
  let widthDistanceFromCenterForDiv,heigthDistanceFromCenterForDiv; // benyamin's idea for different place for magnifier on first round

  let letterIndex = angleOffset<0?(-angleOffset+1)%34:(34-angleOffset+1)
  letterIndex=letterIndex%34
  if(Math.abs(angleOffset)%2===1){
    if(distance<middleWidth*0.8){
      widthDistanceFromCenter = middleWidth * 0.75
      heigthDistanceFromCenter = middleHeight * 0.75
      widthDistanceFromCenterForDiv = middleWidth * 0.65
      heigthDistanceFromCenterForDiv = middleHeight * 0.65
    }else{
      angleOffset = Math.round(angleOffset/2) * 2 
      widthDistanceFromCenter = middleWidth * 0.85
      heigthDistanceFromCenter = middleHeight * 0.85
      widthDistanceFromCenterForDiv = middleWidth * 0.85
      heigthDistanceFromCenterForDiv = middleHeight * 0.85
    }
  }else{
    if(distance<middleWidth*0.8){

    }else{
      widthDistanceFromCenter = middleWidth * 0.85
      heigthDistanceFromCenter = middleHeight * 0.85
      widthDistanceFromCenterForDiv = middleWidth * 0.85
      heigthDistanceFromCenterForDiv = middleHeight * 0.85
    }
    
    
  }
  
  let roundedAngel = angleOffset * angleStep
  let newX = middleWidth + widthDistanceFromCenter * Math.cos(roundedAngel)
  let newY = middleHeight+ heigthDistanceFromCenter * Math.sin(roundedAngel)
  let newXForDiv = middleWidth + widthDistanceFromCenterForDiv * Math.cos(roundedAngel)
  let newYForDiv = middleHeight+ heigthDistanceFromCenterForDiv * Math.sin(roundedAngel)



  // let localDistance = Math.sqrt(Math.pow(newX-activePosition.x,2) + Math.pow(newY-activePosition.y,2))
  let localDistance = Math.sqrt(Math.pow(newXForDiv-activePosition.x,2) + Math.pow(newYForDiv-activePosition.y,2))

  if(localDistance > 0 && localDistance<15 && isMoved){
    magnifierBorderColor="rgba(0,255,0,0.4)"
    magnifierBackgroundColor= "radial-gradient(circle, rgba(255,255,255,0) 30%, rgba(0,255,0,0.4) 100%)"
    if(selectedLetter!==letters[lang][(letterIndex-1+34)%34])
      setSelectedLetter(letters[lang][(letterIndex-1+34)%34])
    
  }else if(localDistance>=15 && localDistance<50){
    magnifierBorderColor="rgba(255,255,255,0.5)"
    magnifierBackgroundColor= props.magnifierBackgroundColor
    if(selectedLetter!=="")
      setSelectedLetter("")
  }

    let divPosition = {
      x: newX - positionOffset + magnifierOffsetX,
      y: newY - positionOffset + magnifierOffsetY
    };
    
  let position = {
    x: itemPosition.x - newX + positionOffset - magnifierBorderSize,
    y: itemPosition.y - newY + positionOffset - magnifierBorderSize
  };
  
  useEffect(()=>{
    imageRef.current.addEventListener('touchstart',(e)=>{
      setIsMoved(true)
    })

    imageRef.current.addEventListener('touchend',(e)=>{
      setIsFinished(true)
    })

    imageRef.current.addEventListener('mousedown',(e)=>{
      setIsMoved(true)
    })
    imageRef.current.addEventListener('mouseup',(e)=>{
      setIsFinished(true)
    })
    
    imageRef.current.addEventListener('mousemove',(e)=>{
      setIsMoved(true)
    })
  },[])
  

  return (
      <>
      <Image
      ref={imageRef}
        style={{
          width: "100%",
          display: "block",
          boxSizing: "border-box",
          cursor: legalSize ? cursorStyle : "default"
        }}
        src={imageSrc}
        alt={imageAlt}
        onImageLoad={onImageLoad}
        onLoadRefresh={onLoadRefresh}
      />
      
      <div
        style={{
          ...styles.getZoomContainerStyle(
            magnifierSizeNum,
            magnifierSizeNum,
            true
          ),
          visibility: "visible",
          borderRadius,
          zIndex: "1",
          border: `${magnifierBorderSize}px solid ${magnifierBorderColor}`,
          transform: `translate(${divPosition.x}px, ${divPosition.y}px)`,
          background: magnifierBackgroundColor,
        }}
      >
        <Image
          style={styles.getLargeImageStyle(position.x, position.y, true)}
          ref={itemRef}
          src={largeImageSrc || imageSrc}
          alt={imageAlt}
          onImageLoad={onLargeImageLoad}
          onLoadRefresh={onLoadRefresh}
        />
        <div
        style={{
          zIndex:100,
          height:"100%",
          width:"100%",
          background:magnifierBackgroundColor,
          top:0,
          left:0,
          borderRadius:"50%"
        }}
      >
        
      </div>
      </div>
      
      {renderOverlay ? renderOverlay(active) : null}
      </>
      
  );
};

export default GlassRenderer;